<template>
  <div>
    <el-card class="box-card"
      v-for="remark in remarks"
      :key="remark.id">
      <text-field
          v-model="remark.title"
          :base="base"
          name="remark_title"
          :disabled="true">
      </text-field>
      <text-field
          v-model="remark.content"
          :base="base"
          name="remark_content"
          type="textarea"
          :disabled="true">
      </text-field>
    </el-card>
    <text-field
      v-model="member_note"
      :base="base"
      name="member_note"
      type="textarea"
      :disabled="true"
      >
    </text-field>
    <text-field
      v-model="branch_note"
      :base="base"
      name="branch_note"
      type="textarea"
      :disabled="true"
      >
    </text-field>
  </div>
</template>

<script>

export default {
  name: 'reservation-remark',
  props: {
    base: {
      type: String,
      default: ''
    },
    member_note: {
      type: String,
      default: ''
    },
    branch_note: {
      type: String,
      default: ''
    },
    remarks: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
    }
  },
  methods: {
  },
  mounted () {
  },
  watch: {
  }
}
</script>
